export const PersonalizationBoostingExperimentFlags = {
  boost_exploration: '0.5',
  boost_coefficient: '0',
  boost_limit_part: '0.5',
} as Gallery.Models.Url.ASPExperimentFlags

export const IMAGE_PLACEHOLDER_BOOST_KEY = 'ImagePlaceholder'

export const IMAGE_PLACEHOLDER_BOOST_WEIGHT = 1
